import { Button, Popover, usePopover, enums } from 'edrolo-ui';
import PT from 'prop-types';

const hintContentStyle = {
  padding: '16px 24px',
  maxWidth: '360px',
};

const hintHeadingStyle = {
  margin: '0 0 8px 0',
  fontSize: '14px',
  fontWeight: 'bold',
};

const hintBodyStyle = {
  fontSize: '14px',
  lineHeight: '1.5',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
};

const HintPopover = ({ hint }) => {
  const { togglePopover, closePopover, anchor, isOpen } = usePopover();

  if (!hint) {
    return null;
  }

  return (
    <>
      <Button
        variant={enums.Variant.OUTLINE}
        size={enums.Size.SMALL}
        onClick={togglePopover}
      >
        Hint
      </Button>
      <Popover
        isOpen={isOpen}
        anchor={anchor}
        closePopover={closePopover}
        placement={enums.Placement.BOTTOM_START}
      >
        <div style={hintContentStyle}>
          <h4 style={hintHeadingStyle}>HINT</h4>
          <div
            style={hintBodyStyle}
            dangerouslySetInnerHTML={{ __html: hint }}
          />
        </div>
      </Popover>
    </>
  );
};

HintPopover.propTypes = {
  hint: PT.string,
};

HintPopover.defaultProps = {
  hint: '',
};

export default HintPopover;
